import { createSlice } from '@reduxjs/toolkit';
import { createWithdrawEmailExplorerVerification } from '../views/Earnings/Withdraw/Withdraw.actions';

export interface WithdrawSliceType {
  loading: boolean;
}

const initialState = {
  loading: false
} as WithdrawSliceType;

const withdrawSlice = createSlice({
  name: 'withdraw',
  initialState,
  reducers: {
    // changeAvailableBalance(state, { payload }) {
    //   if (state.info) {
    //     state.info.totalEarnings.availableBalance =
    //       state.info.totalEarnings.availableBalance - payload;
    //   }
    // }
  },

  extraReducers: (builder) => {
    builder.addCase(
      createWithdrawEmailExplorerVerification.pending,
      (state) => {
        state.loading = true;
      }
    );
    builder.addCase(
      createWithdrawEmailExplorerVerification.fulfilled,
      (state, { payload }) => {
        state.loading = false;
      }
    );
    builder.addCase(
      createWithdrawEmailExplorerVerification.rejected,
      (state) => {
        state.loading = false;
      }
    );
  }
});

export default withdrawSlice.reducer;
